
import React from "react";
import { Message } from "@/services/chatService";
import { cn } from "@/lib/utils";
import { format } from "date-fns";

interface MessageItemProps {
  message: Message;
}

export const MessageItem: React.FC<MessageItemProps> = ({ message }) => {
  const isSender = message.is_sender;
  const time = message.sent_at ? format(new Date(message.sent_at), 'HH:mm') : '';
  
  return (
    <div className={cn(
      "flex mb-3",
      isSender ? "justify-end" : "justify-start"
    )}>
      <div className={cn(
        "max-w-[80%] px-4 py-2 rounded-lg",
        isSender 
          ? "bg-[#00B6F0] text-white rounded-br-none" 
          : "bg-[#1E293B] text-gray-100 rounded-bl-none"
      )}>
        <p className="break-words">{message.message}</p>
        <span className={cn(
          "text-xs block mt-1",
          isSender ? "text-blue-100" : "text-gray-400"
        )}>
          {time}
        </span>
      </div>
    </div>
  );
};
